import { Log } from "features/shared/types/info";
import { LogAction, LogActionTypes } from "../types/actions";

const initialState: Log[] = [];

const logsReducer = (state = initialState, action: LogActionTypes): Log[] => {
    switch (action.type) {
        case LogAction.SET_LOGS:
            return action.logs;
        default:
            return state;
    }
};

export default logsReducer;
